import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { store } from "./store/store";
import cookie from "js-cookie";
import axios from "axios";
import "bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css";
import "bootstrap-v4-rtl/dist/js/bootstrap.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery";
import "popper.js";
import "react-toastify/dist/ReactToastify.css";
import "../src/styles/global.scss";
import * as types from "../src/store/types";
import { IntlProvider } from "react-intl";

import Arabic from "./lang/ar.json";
import English from "./lang/en.json";

let token = cookie.get("token");

function Root() {
	const [locale, setLocale] = React.useState({ lang: "ar", messages: Arabic });

	React.useEffect(() => {
		const lang = localStorage.getItem("lang") || "ar";
		if (lang === "en") {
			setLocale({ lang: "en", messages: English });
			document.body.setAttribute("dir", "ltr");
			document.documentElement.lang = "en";
			document.title = "Dashboard";
		} else {
			setLocale({ lang: "ar", messages: Arabic });
			document.body.setAttribute("dir", "rtl");
			document.documentElement.lang = "ar";
			document.title = "لوحة التحكم";
		}
	}, []);

	return (
		<Provider store={store}>
			<IntlProvider messages={locale.messages} locale={locale.lang}>
				<ToastContainer rtl={locale.lang === "ar"} position="bottom-left" />
				<App />
			</IntlProvider>
		</Provider>
	);
}

function mount() {
	ReactDOM.render(
		<React.StrictMode>
			<Root />
		</React.StrictMode>,
		document.getElementById("root")
	);
}

if (token) {
	axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
	axios
		.get(`${process.env.REACT_APP_API_URL}/profile`)
		.then(response => {
			store.dispatch({ type: types.LOG_IN, payload: response.data });
			mount();
		})
		.catch(e => {
			mount();
		});
} else {
	mount();
}
